import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import Elevio from 'elevio/lib/react'

export const ElevioIntegration = ({ keywords }) => {
  const { username, userhash = '', firstName = '', lastName = '', assignedRole = null } = useSelector(state => state.auth)
  const { userRoles = [] } = useSelector(state => state.userRoles)

  const [elevioGroups, setElevioGroups] = useState([])

  useMemo(() => {
    if (userRoles && Array.isArray(userRoles) && Boolean(assignedRole)) {
      const filteredRoles = userRoles.reduce((arr, role) => {
        if (role && role.roleID && role.roleID === assignedRole) { arr.push(role.roleName.toLowerCase()) }
        return arr
      }, [])

      if (filteredRoles.length) { setElevioGroups(filteredRoles) }
    }
  }, [userRoles, assignedRole])

  const handleElevioLoad = (instance) => {
    instance.setUser({
      first_name: firstName,
      last_name: lastName,
      email: username,
      user_hash: userhash,
      groups: elevioGroups
    })

    setTimeout(() => { instance.initialize() }, 1000)
  }

  return (
    <div>
      {
        keywords && username && userhash && Boolean(elevioGroups.length) ? (
          <Elevio
            settings={{
              autoInitialize: false,
              loggedin_only: true,
            }}
            accountId='62aa0fa64a5c3'
            keywords={keywords}
            onLoad={handleElevioLoad}
          />
        ) : (
          <></>
        )
      }
    </div>
  )
}

export default ElevioIntegration
